"use client"

import type React from "react"
import { Analytics } from "@vercel/analytics/next"
import { Suspense } from "react"
import { Loading } from '@/components/index'
import { Provider } from 'react-redux';
import { store } from '@/store';
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import "./globals.css"

export default function Index({
  children,
}: Readonly<{
  children: React.ReactNode
}>) {
  return (
    <Provider store={store}>
      <Suspense fallback={null}>
        <ConfigProvider locale={zhCN}>
          {children}
        </ConfigProvider>
        <Analytics />
        <Loading></Loading>
      </Suspense>
    </Provider>
  )
}
